// NATIVE 
import { Button, Card, CardContent, Chip, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, Grid, Switch, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';


// INSTALLED 
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { createConfigShiftEmployeesStore } from '../store/shifts_employees';
import { useDispatch } from 'react-redux';

// CUSTOM 


export const CardConfiguration = ({props}:any) => {



  // USE DISPATCH 
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [data_autogenerar, setDataAutogenerar] = useState<any>([]);
  const [data_status, setDataStatus] = useState<any>([]);
  const [data_sabados_domingos, setDataSabadosyDomingos] = useState<any>([]);

    const [percentage, setPercentageUpload]   = useState(0);


  useEffect(() => {
    setData(props);
    setIdsCheckeds(props)
  }, [props]);


  const setIdsCheckeds = (props:any) => {

    const itemsAutogenerar         =  props && props.filter( (item:any) => item.auto_generate ) .map((item:any) => item._id); 
    const itemsStatus              =  props && props.filter( (item:any) => item.status ) .map((item:any) => item._id); 
    const itemsSabadosyDomingos    =  props && props.filter( (item:any) => item.sundays_and_holidays ) .map((item:any) => item._id); 

    setDataStatus(itemsStatus);
    setDataAutogenerar(itemsAutogenerar);
    setDataSabadosyDomingos(itemsSabadosyDomingos);
  }
  





  const handleChangeAutogenerate = (id:any) => {
    
    let depeedItem = JSON.parse(JSON.stringify(data_autogenerar));
    let element = depeedItem.indexOf(id);

    if (element !== -1) {
        depeedItem.splice(element, 1);
    }else{
        depeedItem.push(id);
    }

    setDataAutogenerar(depeedItem);

  };


  const handleChangeStatus = (id:any) => {
    
    let depeedItem = JSON.parse(JSON.stringify(data_status));
    let element = depeedItem.indexOf(id);
    if (element !== -1) {
        depeedItem.splice(element, 1);
    }else{
        depeedItem.push(id);
    }

    setDataStatus(depeedItem);
    
  };



  const handleChangeSabadosDomingos = async(id:any) => {
    
    let depeedItem = JSON.parse(JSON.stringify(data_sabados_domingos));
    let element = depeedItem.indexOf(id);
    if (element !== -1) {
        depeedItem.splice(element, 1);
    }else{
        depeedItem.push(id);
    }

    await setDataSabadosyDomingos(depeedItem);
    
  };


  const generateShiftsEmployees = async(id:string) => {

        await dispatch( createConfigShiftEmployeesStore(id, setPercentageUpload) )
  }
  


  return (
    <>
        {
            data && data.length > 0 && 
            <Grid container spacing={3} sx={{ padding: 3 }}>
            {data.map( (item:any, index:any) => (
              <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}  key={index}>
                <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography gutterBottom variant="h5" component="h2">
                      {item.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {'item.description'}
                    </Typography>
                    
                  </CardContent>

                  


                  {
                     item.status &&
                     <Button
                        startIcon={<AccessTimeIcon/>}
                        variant="contained"
                        size='small'
                        sx={{ margin: 2 }}
                        onClick={ () => generateShiftsEmployees(item._id)}>
                        Generar Turnos
                    </Button>
                  }
                  {
                     item.status &&
                        <Button
                            startIcon={<VisibilityIcon />}
                            size='small'
                            color='success'
                            variant="contained"
                            sx={{ marginLeft: 2, marginRight: 2, marginBottom: 2, justifyContent: 'center' }}
                            onClick={() => alert(`Editando: ${item.name}`)}>
                                detalle
                        </Button>
                  }


                  <FormControl component="fieldset" variant="standard" sx={{ margin: 2 }}>
                    <FormLabel component="legend">Assign responsibility</FormLabel>
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Switch checked={ data_autogenerar.includes(item._id) ? true : false} onChange={() => handleChangeAutogenerate(item._id)}  />
                            }
                            label={ item.auto_generate ? <Chip size='small' label="Autogener" sx={{ color: '#5DCC0A', background: '#E4F6D6', fontWeight: 700 }} /> : <Chip size='small' label="Autogenerar" sx={{ color: '#FF4C51', background: '#FFE2E3', fontWeight: 700 }} /> } 
                        />
                        <FormControlLabel
                        control={
                            <Switch checked={ data_status.includes(item._id) ? true : false}  onChange={() => handleChangeStatus(item._id)}  />
                        }
                            label={ item.status ? <Chip size='small' label="Activo" sx={{ color: '#5DCC0A', background: '#E4F6D6', fontWeight: 700 }} /> : <Chip size='small' label="Inactivo" sx={{ color: '#FF4C51', background: '#FFE2E3', fontWeight: 700 }} /> } 
                        />
                        <FormControlLabel
                        control={
                            <Switch checked={ data_sabados_domingos.includes(item._id) ? true : false}  onChange={() => handleChangeSabadosDomingos(item._id)} name="sabadosydomingos" />
                        }
                        label={ item.sundays_and_holidays ? <Chip size='small' label="Sabados y domingos" sx={{ color: '#5DCC0A', background: '#E4F6D6', fontWeight: 700 }} /> : <Chip size='small' label="Sabados y domingos" sx={{ color: '#FF4C51', background: '#FFE2E3', fontWeight: 700 }} /> } 
                        />
                    </FormGroup>
                    <FormHelperText>Parametros basicos</FormHelperText>
                  </FormControl>
                  
                </Card>
              </Grid>
            ))}
          </Grid>
        }
        
    </>
  )
}
